<template>
  <div class="RegisteredOwnership flex-jc-bt">
    <div class="flex-50 left-side">
      <SpCard custom-class="sp-color-bg-4 card-content">
        <div class="flex item">
          <div class="flex-25 label">{{ $l('RegisterNo') }}</div>
          <div class="flex flex-30">
            <SpInput v-model="shipInfo.registrationNo" :validate-reg="/^((?=.[a-zA-Z])[A-Za-z0-9- ]{8,64})?$/" type="warn" />
          </div>
        </div>
        <div class="flex item">
          <div class="flex-25 label">{{ $l('PortofRegistry') }}</div>
          <div class="flex flex-30">
            <SpInput v-model="portOfRegistry" :validate-reg="/^((?=.[A-Za-z])[A-Za-z0-9()-.,’” ]{2,64})?$/" type="warn" />
          </div>
        </div>
        <div class="flex item">
          <div class="flex-25 label">{{ $l('RegisteredOwnership') }}</div>
          <div class="flex-70">
            <SpSelect v-model="shipInfo.registeredOwnerIds" type="warn" multi-select>
              <SpSelectOption v-for="(owner, key) in shipOwnerOptions" :key="key" :value="key" :label="owner" />
            </SpSelect>
          </div>
        </div>
      </SpCard>
      <p class="reminder">
        {{ $l('Reminder') }}
      </p>
    </div>
    <div class="flex-48 mg-t-40 right-side sp-color-bg-4">
      <ShipInfoTable v-model="shipInfo" />
      <div class="fs-int outer-gap sp-color-11 text-left">{{ $l('SomeSupportingFilesPicturesPDForOthers') }}</div>
      <div class="fs-int mg-t-20 opacity-50 sp-color-11 text-left">{{ $l('CerificateofRegistry') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/reg/cert" accept="image/*" />
      <div class="fs-int mg-t-20 opacity-50 sp-color-11 text-left">{{ $l('Others') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/reg/other" accept="MIME_type" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpCard from '@/components/common/SpCard'
import SpInput from '@/components/common/SpInput'
import SpSelect from '@/components/common/SpSelect'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import ShipInfoTable from '@/components/shipOwner/tonnages/newTonnage/ShipInfoTable'
import { getShipOwnerApi } from '@/request/APIs/so'
import SpSelectOption from '@/components/common/SpSelectOption'
export default {
  name: 'RegisteredOwnership',

  nameSpace: 'shipOwner.tonnages.newTonnage.RegisteredOwnership',

  components: {
    SpSelectOption,
    SpCard,
    SpInput,
    SpSelect,
    SpUploadGroup,
    ShipInfoTable
  },

  props: {
    modelValue: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  emits: ['update:modelValue'],

  data () {
    return {
      shipOwnerOptions: {}
    }
  },

  computed: {
    shipInfo: {
      get () {
        return this.modelValue
      },

      set (nv) {
        this.$emit('update:modelValue', nv)
      }
    }
  },

  created () {
    this.getShipOwner()
  },

  mounted () {
  },

  methods: {
    // 获取船舶产权公司选项
    getShipOwner () {
      getShipOwnerApi().then(res => {
        this.shipOwnerOptions = res.data
      })
    }
  }
}
</script>

<style scoped lang="less">
.RegisteredOwnership{
  .card-content{
    padding: @gap;
    .item{
      margin:@gap*2 0 @gap 0 !important;
    }
  }
  .right-side{
    box-sizing:border-box;
    padding:@gap;
  }
  .outer-gap{
    margin-top: @gap*3;
  }
}
</style>
